import HeroHeader from './HeroHeader';

export default HeroHeader;
